import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex flex-col items-center justify-center px-4 py-20 overflow-hidden bg-navy-900" data-id="element-101">
      {/* Background glow */}
      <div className="absolute inset-0 bg-radial-glow opacity-60 pointer-events-none" data-id="element-102" />

      <div className="max-w-4xl mx-auto w-full flex flex-col items-center text-center relative z-10" data-id="element-103">
        <FadeIn delay={0.1} data-id="element-104">
          <div className="relative mb-10 group" data-id="element-105">
            <div className="absolute -inset-1 bg-gold/20 rounded-xl blur-xl group-hover:bg-gold/30 transition-all duration-500" data-id="element-106" />
            <img src="https://cdn.magicpatterns.com/uploads/5bNhQK1tZzNNjLjKiwhqc6/portada_dos.png" alt="SOS: Bebé Duerme Cover" className="relative w-full max-w-[280px] md:max-w-sm rounded-xl shadow-2xl border border-gold/30" data-id="element-107" />
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-108">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-cream mb-6 leading-tight" data-id="element-109">
            Recupera tus noches y <br className="hidden md:block" data-id="element-110" />
            <span className="text-gold italic" data-id="element-111">protege tu empleo</span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-112">
          <p className="text-xl md:text-2xl text-muted mb-12 max-w-2xl font-light" data-id="element-113">
            El método de sueño para padres que trabajan en USA.
          </p>
        </FadeIn>

        <FadeIn delay={0.7} className="w-full flex justify-center" data-id="element-114">
          <a href="https://TU-LINK-DE-HOTMART" target="_blank" rel="noopener noreferrer" data-id="element-115">
  <CTAButton data-id="element-116">
    ¡QUIERO VOLVER A DORMIR HOY!
  </CTAButton>
</a>
        </FadeIn>
      </div>
    </section>;
}